/**
 * @file routes/_app/settings/verification-schemes.tsx
 * @description 驗證方案字典維護頁（驗證制度 + 法規依據）。
 *
 * 對應 clients.scheme（pgEnum TOP/TAP/ECO）。每筆有：
 *  - code：方案代碼（TOP/TAP/ECO），全域唯一
 *  - name：制度顯示名（如 有機農產品驗證制度）
 *  - legalBasis：法規依據（客戶建檔時可自動帶出）
 * 字典項供「編輯客戶 → 驗證方案」下拉與法規依據顯示。
 */

import { createFileRoute } from '@tanstack/react-router';
import { Form, Input, Select, Tag } from 'antd';
import { LookupAdminPage } from '@/components/settings/LookupAdminPage';

/** 方案代碼選項（與 verificationScheme enum 對齊） */
const CODE_OPTIONS = [
  { value: 'TOP', label: 'TOP' },
  { value: 'TAP', label: 'TAP' },
  { value: 'ECO', label: 'ECO' },
];

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/settings/verification-schemes')({
  component: VerificationSchemesPage,
});

/** 驗證方案維護頁（含 code + 法規依據欄） */
function VerificationSchemesPage() {
  return (
    <LookupAdminPage
      resource="verification-schemes"
      resourceLabel="驗證方案"
      description="驗證制度與法規依據（TOP 有機農產品驗證制度 / TAP 產銷履歷農產品驗證制度 / ECO 友善·其他）。「名稱」即制度顯示名。"
      nameMaxLength={50}
      extraTableColumns={[
        {
          title: '方案代碼',
          dataIndex: 'code',
          width: 100,
          render: (v: string | null) => (v ? <Tag>{v}</Tag> : '—'),
        },
        {
          title: '法規依據',
          dataIndex: 'legalBasis',
          render: (v: string | null) => v || '—',
        },
      ]}
      extraFormFields={
        <>
          <Form.Item name="code" label="方案代碼" rules={[{ required: true }]}>
            <Select placeholder="TOP / TAP / ECO" options={CODE_OPTIONS} />
          </Form.Item>
          <Form.Item name="legalBasis" label="法規依據">
            <Input.TextArea
              rows={2}
              maxLength={2000}
              placeholder="如 有機農業促進法暨相關子法彙編"
            />
          </Form.Item>
        </>
      }
    />
  );
}
